import { Box, colors, Container, Grid, IconButton, Typography } from "@mui/material";
import { Item } from "../../styles/common";
import { Table } from "../../common/table/Table";
import React, { useCallback, useEffect, useState } from "react";
import { useQuery } from "@apollo/client";
import { GET_POINT_HISTORY } from "./pointHistory.queries";
import { PointHistoryFilter, PointHistoryFilterData } from "./PointHistoryFilter";
import { config } from "../../config";

const perPage = config.rowsPerPage;

export const PointHistory: React.FC<any> = (props: any): JSX.Element => {
  const username = props.username;
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(perPage);
  let variables = React.useRef<any>({
    filter: {
      filters: [{
        field: 'username',
        operator: 'equals',
        value: username,
      }],
      operator: 'AND',
    },
    pagination: {
      skip: 0,
      take: perPage,
    },
  });
  const { data, loading, refetch } = useQuery(GET_POINT_HISTORY, { variables: variables.current });

  useEffect(() => {
    variables.current = {
      ...variables.current,
      pagination: {
        take: rowsPerPage,
        skip: page * rowsPerPage,
      },
    };
    refetch(variables.current);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [page, rowsPerPage]);

  const onFilter = useCallback((filter: PointHistoryFilterData) => {
    console.log('filter', filter);
    variables.current = {
      ...variables.current,
      filter: {
        filters: [
          {
            field: 'username',
            operator: 'equals',
            value: username,
          },
          ...filter.filters,
        ],
        operator: filter.operator,
      },
    };
    refetch(variables.current);
  }, [refetch, username]);

  if (loading) return <h4>Loading...</h4>;
  return (
    <Container sx={{ backgroundColor: colors.common.white, p: '2rem', border: '1px solid black' }}>
      <Box sx={{ flexGrow: 1 }}>
        <Grid container spacing={2}>
          <Grid item xs={11}>
            <Item>
              <Typography sx={{ m: 2 }} variant="h4">Point transaction history</Typography>
            </Item>
          </Grid>
          <Grid item xs={1}>
            <IconButton onClick={() => {props.handleClose()}}>
              x
            </IconButton>
          </Grid>
          <Grid item xs={12}>
            <Item>
              <PointHistoryFilter onFilter={onFilter} />
            </Item>
          </Grid>
          <Grid item xs={12}>
            <Item>
              <Table
                page={page}
                setPage={setPage}
                rowsPerPage={rowsPerPage}
                setRowsPerPage={setRowsPerPage}
                loading={loading}
                columns={[
                  {
                    label: "Username",
                    key: "username",
                    rowRender: (row) => `${row.User.username}`,
                  },

                  {
                    label: "First Name",
                    key: "firstName",
                    rowRender: (row) => `${row.User.firstName}`,
                  },
                  {
                    label: "Last Name",
                    key: "lastName",
                    rowRender: (row) => `${row.User.lastName}`,
                  },
                  {
                    label: "Email",
                    key: "email",
                    rowRender: (row) => `${row.User.email}`,
                  },
                  {
                    label: "Amount",
                    key: "amount",
                    textAlign: "right",
                  },
                  {
                    label: "Type",
                    key: "type",
                  },
                  {
                    label: "Created At",
                    key: "createdAt",
                    rowRender: (row) => `${new Date(row.createdAt).toLocaleString()}`,
                  },
                ]}
                rows={data?.getPointHistory?.pointHistory ?? []}
                total={data?.getPointHistory?.total ?? 0}
              />
            </Item>
          </Grid>
        </Grid>
      </Box>
    </Container>
  );
};